// extracted by mini-css-extract-plugin
export default {"fileUploadIcon":"BuildingForm_fileUploadIcon__mLkyM"};